import { render, staticRenderFns } from "./r-dropdown-child.vue?vue&type=template&id=3c0116bc&scoped=true"
import script from "./r-dropdown-child.vue?vue&type=script&lang=js"
export * from "./r-dropdown-child.vue?vue&type=script&lang=js"
import style0 from "./r-dropdown-child.vue?vue&type=style&index=0&id=3c0116bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0116bc",
  null
  
)

export default component.exports